import cx from 'classnames';
import React from 'react';
import { Key } from 'w3c-keys';
import { Avatar } from '../../../../avatar';
import { ObjectTableColumnKey } from '../../column-util/object-table-column-util';
import styles from './avatar-column.module.scss';
const areEqual = (prevProps, nextProps) => {
    var _a, _b;
    const prev = ((_a = prevProps.colDef) === null || _a === void 0 ? void 0 : _a.colId)
        ? prevProps.data[prevProps.colDef.colId]
        : {};
    const next = ((_b = nextProps.colDef) === null || _b === void 0 ? void 0 : _b.colId)
        ? nextProps.data[nextProps.colDef.colId]
        : {};
    // Only compare avatar-specific fields to prevent unnecessary re-renders
    // when other row data changes (e.g., isFavorite field)
    // Note: We don't compare handler as it's recreated on each render
    // but remains functionally equivalent
    return (prev.name === next.name &&
        prev.src === next.src &&
        prev.id === next.id &&
        prev.isNameLink === next.isNameLink);
};
export const AvatarColumn = React.memo(({ data, colDef }) => {
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || ObjectTableColumnKey.Author];
    const avatarColumn = {
        ...fieldValues,
    };
    const onAvatarClick = (event) => {
        if (avatarColumn.handler) {
            const menuItemEvent = {
                id: avatarColumn.id,
                label: avatarColumn.name,
                event,
                data,
            };
            avatarColumn.handler(menuItemEvent);
        }
    };
    const onEnter = (event) => {
        if (event.key === Key.Enter) {
            onAvatarClick(event);
        }
    };
    const isAvatarClickable = !!avatarColumn.handler;
    return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    React.createElement("div", { className: cx(styles.avatarColumnContainer, {
            [styles.clickable]: isAvatarClickable,
        }), "data-testid": "avatar-column-testid", onClick: onAvatarClick, onKeyDown: onEnter, role: "button", tabIndex: 0 },
        React.createElement(Avatar.Tray, { items: [avatarColumn], size: "m", className: styles.avatarTray, isNameLink: avatarColumn.isNameLink })));
}, areEqual);
//# sourceMappingURL=avatar-column.js.map